import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';

import { __ } from '../../../../utils.jsx';

var NewDirectoryPanel = createReactClass({
  propTypes: {
    createDirectory: PropTypes.func,
  },

  getDefaultProps: function() {
    return {
      createDirectory: function() {},
    };
  },

  getInitialState: function() {
    return {
      path: '/',
    };
  },

  createDirectory: function() {
    var value = this.refs.input.value;
    this.props.createDirectory(value);
  },

  render: function() {
    return (
      <div>
        <label className="text-register" htmlFor="new-dir-input">
          {__('Nový adresár')}:
        </label>
        <input
          ref="input"
          type="text"
          id="new-dir-input"
          className="ng-pristine ng-untouched ng-valid"
        />
        <a className="button small-margin-left" onClick={this.createDirectory}>
          <span>{__('Vytvoriť')}</span>
        </a>
      </div>
    );
  },
});

export default NewDirectoryPanel;



// WEBPACK FOOTER //
// ./src/js/app/cm/components/mediaBrowser/NewDirectoryPanel.jsx